<script setup lang="ts">
import { FormElMsgProps } from '@/types/form/others/form-el-msg';
import { computed } from 'vue';

const props = defineProps<FormElMsgProps>();
const iconName = computed((): string | undefined => {
  if (!props.msg) return undefined;
  const iconMap: Record<string, string> = {
    error: 'error',
    success: 'success',
  };
  return iconMap[props.msg.type];
});
</script>

<template>
  <div class="f-el-msg" :class="[msg?.type]">
    <div class="f-el-msg__inner" v-if="msg">
      <icon :name="iconName" size="xxs" />
      <span v-html="msg.message" />
    </div>
  </div>
</template>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/functions';
@import '../../styles/mixins';
.f-el-msg {
  position: relative;
  height: 16px;
  &__inner {
    position: absolute;
    display: flex;
    gap: 4px;
    font-size: 12px;
    line-height: 16px;
  }
  &.error {
    color: $red;
  }
}
</style>
